import React from 'react';
import styles from './Form.module.css';
import { useTranslation } from 'react-i18next';

import { Table, Checkbox } from '@mantine/core';

const Form = ({ onSubmit, loading, form }) => {
  const { t } = useTranslation();

  const rows = form.getValues().elements.map((element, index) => (
    <Table.Tr key={element.name} className={styles.bodyTr}>
      <Table.Td className={styles.nameTh}>{element.name}</Table.Td>

      <Table.Td className={styles.creationTh} align='center'>
        <Checkbox
          className={styles.checkbox}
          disabled={loading}
          key={form.key(`elements.${index}.create`)}
          {...form.getInputProps(`elements.${index}.create`, { type: 'checkbox' })} 
        />
        </Table.Td>

      <Table.Td className={styles.creationTh} align='center'>
        <Checkbox
          className={styles.checkbox}
          disabled={loading}
          key={form.key(`elements.${index}.edit`)}
          {...form.getInputProps(`elements.${index}.edit`, { type: 'checkbox' })} 
        />
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <div className={styles.wrapper}>
      <form
        className={styles.form}
        onSubmit={form.onSubmit(onSubmit)}
      >
        <Table stickyHeader stickyHeaderOffset={60}>
          <Table.Thead className={styles.thead}>
            <Table.Tr className={styles.headTr}>
              <Table.Th className={styles.headThName}>{t('organization.permission.table.title1')}</Table.Th>
              <Table.Th className={styles.headTh}>{t('organization.permission.table.title2')}</Table.Th>
              <Table.Th className={styles.headTh}>{t('organization.permission.table.title3')}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
      </form>
    </div >
  )
}

export default Form;
